import React from 'react';
import styles from './ToggleSwitch.module.css';

interface ToggleSwitchProps {
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
  label?: string;
  explanation?: string;
  id?: string;
  className?: string;
  statusIndicator?: {
    text: string;
    type: 'conflict';
  };
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  checked,
  onChange,
  disabled = false,
  label,
  explanation,
  id,
  className = '',
  statusIndicator
}) => {
  return (
    <label 
      className={`${styles.preferenceItem} ${className}`}
      htmlFor={id}
    >
      <div className={styles.toggleWrapper}>
        <input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        <div className={styles.toggleSwitch}></div>
        <div className={styles.labelContainer}>
          {label && <span className={styles.preferenceLabel}>{label}</span>}
          {statusIndicator && (
            <div className={`${styles.statusIndicator} ${styles[statusIndicator.type]}`}>
              {statusIndicator.text}
            </div>
          )}
        </div>
      </div>
      {explanation && (
        <div className={styles.explanation}>
          <p>{explanation}</p>
        </div>
      )}
    </label>
  );
};

export default ToggleSwitch;
